import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/img/04_04.jpg";
import Reveal from "../common/Reveal";

const ImgBanner = () => {
  return (
    <section className="relative isolate overflow-hidden">
      <img
        src={bannerImg}
        alt="집중해서 일하는 MTST 구성원의 모습"
        className="animate-image-zoom absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-primary-950/70" />

      <Reveal className="relative mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-8">
        <h2 className="break-keep text-3xl font-bold leading-snug text-white sm:text-4xl">
          우리의 열정이
          <br />
          세상에 미치는 영향
        </h2>
        <p className="mt-4 text-base text-gray-200">
          서로 다른 사람들이 모여 한 방향으로 나아갑니다
        </p>
        <Link
          to="/introduction"
          className="mt-8 inline-flex items-center rounded-md bg-white px-6 py-3 text-base font-semibold text-primary-900 transition-all duration-200 hover:-translate-y-0.5 hover:bg-gray-100 hover:shadow-lg"
        >
          회사 소개 더 보기
        </Link>
      </Reveal>
    </section>
  );
};

export default ImgBanner;
